var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCircleCheckSvgWhite = function SvgCircleCheckSvgWhite(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "white",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check-normal-c") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    className: "icon-color"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn_check-normal",
    "data-name": "icn/check-normal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6,12A9.6,9.6,0,0,0,2.4,12M0,12a12,12,0,0,1,24,0M2.4,           12a9.6,9.6,0,0,0,19.2,0M24,12A12,12,0,0,1,0,12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-6",
    points: "6.71 11.59 5.29 13.01 9.99 17.71 19 8.71 17.58 7.29 9.99           14.88 6.71 11.59"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCircleCheckSvgWhite);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CircleCheckSVGWhite.9b1627d5d6aea8442c982c2f1ff8bead.svg";